import BaseApi from "./baseApi";

export default class EurocodeExceptionApi extends BaseApi {
    async getAll(): Promise<EurocodeException[]> {
        return await this.fetchGet("/api/eurocodeexception");
    }

    async createOrUpdate(exception: EurocodeException): Promise<EurocodeException> {
        return await this.fetchPost("/api/eurocodeexception", exception);
    }

    async delete(id: string): Promise<boolean> {
        return await this.fetchDelete(`/api/eurocodeexception?id=${id}`);
    }
}
